import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  gifts: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "gifts",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getGift.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getGift.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      gifts: payload.data,
      totalCount: payload.totalcount,
    }));
    builder.addCase(Act.getGift.rejected, (state, action) => ({
      ...state,
      loading: false,
      gifts: [],
      totalCount: 0,
    }));

    // //add category
    builder.addCase(Act.addGift.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.addGift.fulfilled,
      (state, { payload }) => (
        console.log(payload),
        {
          ...state,
          loading: false,
        }
      )
    );
    builder.addCase(Act.addGift.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    // edit category
    builder.addCase(Act.editGift.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.editGift.fulfilled,
      (state, { payload }) => (
        console.log(payload),
        {
          ...state,
          loading: false,
        }
      )
    );
    builder.addCase(Act.editGift.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    // delete category
    builder.addCase(Act.deleteGift.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.deleteGift.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.deleteGift.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default slice;
